import * as types from './action-types'
import omit from 'lodash/omit'

const initialState = {
  isLoading: true,
  isGetting: false,
  isCreating: false,
  isUpdating: false,
  isDeleting: false,
  data: {}
}

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case types.LOADED:
      return { ...state, isLoading: false, data: payload.data || {} }

    case types.GET_REQUEST:
      return {
        ...state,
        isGetting: true
      }

    case types.GET_SUCCESS:
      return {
        ...state,
        isGetting: false,
        data: {
          ...state.data,
          [payload.transcription.transcriptionId]: payload.transcription
        }
      }

    case types.GET_FAILURE:
      return {
        ...state,
        isGetting: false
      }

    case types.CREATE_REQUEST:
      return { ...state, isCreating: true }

    case types.CREATE_SUCCESS:
      return {
        ...state,
        isCreating: false,
        data: {
          ...state.data,
          [payload.transcription.transcriptionId]: payload.transcription
        }
      }

    case types.CREATE_FAILURE:
      return {
        ...state,
        isCreating: false
      }

    case types.UPDATE_REQUEST:
      return {
        ...state,
        isUpdating: true
      }

    case types.UPDATE_SUCCESS:
      return {
        ...state,
        isUpdating: false,
        data: {
          ...state.data,
          [payload.transcription.transcriptionId]: payload.transcription
        }
      }

    case types.UPDATE_FAILURE:
      return {
        ...state,
        isUpdating: false
      }

    case types.DEL_REQUEST:
      return { ...state, isDeleting: true }

    case types.DEL_SUCCESS:
      return {
        ...state,
        isDeleting: false,
        data: omit(state.data, payload.transcriptionId)
      }

    case types.DEL_FAILURE:
      return { ...state, isDeleting: false }

    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/redux/transcriptions/reducer.js